<template>
  <div class="footer">
    <div class="wrap">
      <div class="foot-top">
        <div class="left">
          <div class="title">
            <span class="blod">联系我们</span>
            <span>(热线接听时间 （9:00-12:00 14:00-18:00）)</span>
          </div>
          <ul>
            <li>认证审核：0755-26224288、36615555</li>
            <li>商务热线：0755-82795034</li>
            <!-- <li>在线纠纷解决(ODR)：0755-83262521</li> -->
           <!-- <li>众信签&众信验证: 0755-82790214</li>
            <li>品信通防伪溯源： 0755-83951036</li>
            <li>微信验证客服电话: 18576409154</li> -->
          </ul>
         <!-- <ul>
            <li>在线纠纷解决(ODR)：0755-83262521</li>
            <li>国际跨境贸易核验服务：0755-83951662</li>
          </ul> -->
          <div>中心地址：广东省深圳市福田区华强南滨河大道3002号无线电管理大厦9楼906</div>
        </div>
        <div class="right">
          <img src="../assets/images/Home/bg/qrcode_ebsorg.png" alt />
          <div>微信公众号</div>
        </div>
      </div>
    </div>
    <div class="wrap1">
      <div class="foot-bottom">
        <div class="left">
          <div>版权所有：深圳市众信电子商务交易保障促进中心 2011-2021 保留一切权利 <a href="http://beian.miit.gov.cn/" target="_blank">粤ICP备12051951号</a></div>
        </div>
        <!-- <div class="right">
          <a
            href="https://cert.ebs.org.cn/75ff6d91-340a-47d0-aa04-5e1bc4e6830d-LeRepCheck.html"
            target="_blank"
          >
            <img src="../assets/images/Home/bg/logo-img.png" alt />
          </a>
        </div> -->
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Footer"
};
</script>
<style lang="less" scoped>
.footer {
  .left {
    width: 90%;
    display: inline-block;
    div{
      a{
        color: #999;
      }
    }
  }
  .right {
    width: 10%;
    display: inline-block;
    vertical-align: middle;
  }
  .wrap {
    width: 100%;
    background-color: #f5f5f5;
    padding: 40px 0 20px;
    .foot-top {
      width: 1040px;
      margin: 0 auto;
      color: #666;
      .left {
        line-height: 28px;
      }
      .right{
          text-align: center;
      }
      .title {
          margin-bottom: 7px;
        span {
          color: #999;
          font-size: 14px;
          &.blod {
            color: #666;
            font-size: 18px;
            margin-right: 20px;
            font-weight: bold;
          }
        }
      }

      ul {
        li {
          display: inline-block;
          // width: 33%;
          margin-right: 40px;
          color: #666;
          line-height: 28px;
        }
      }
    }
  }
  .wrap1 {
    width: 100%;
    background-color: #2d313d;
    padding: 25px 0;
    .foot-bottom {
      width: 1040px;
      margin: 0 auto;
      color: #999;
      .left {
        line-height: 28px;
      }
    }
  }
}
</style>